"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isCustomPackage;

var _packageTemplates = _interopRequireDefault(require("../constants/packageTemplates"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isCustomPackage() {
  var packageData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var compareKeys = ['videoQuantity', 'amendmentsQuantity', 'slaTurnaround', 'storageAllowance', 'resetPeriod'];

  var templatePackage = _packageTemplates.default.find(function (_ref) {
    var name = _ref.name;
    return name === packageData.templatedFrom;
  });

  if (!templatePackage) {
    return false;
  }

  return compareKeys.some(function (key) {
    return templatePackage[key] !== packageData[key];
  });
}